export default {
    extractables: []
};
